import { Button, CircularProgress } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import channelPagesRoleManagement from '../../staticRoleManagement/channelPagesRoleManagement'
import useStyles from './styles/ChannelFooter.styles'

interface ChannelFooterProps {
  isSubmitting: boolean
  loadingForChannel: boolean
}

export const ChannelFooter: React.FC<ChannelFooterProps> = ({
  isSubmitting,
  loadingForChannel
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))
  const hasAccessToModifyChannelDetails = channelPagesRoleManagement
    .find((item) => item.route === '/channels/:id/:channelCode/:page')
    ?.tabs?.find((routeTabItem) => routeTabItem.params.page === 'details')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  return (
    <div className={classes.footer}>
      <Button
        disabled={isSubmitting || !hasAccessToModifyChannelDetails}
        data-cy="SaveChannelButton"
        type="submit"
        variant="contained"
        color="primary"
        size="medium"
        fullWidth={matches}>
        {getTranslate('Save Channel')}
        {loadingForChannel && (
          <CircularProgress
            className={classes.circularProgress}
            size={16}
            color="primary"
          />
        )}
      </Button>
    </div>
  )
}
